import React, { useEffect, useState } from 'react'
import ContentHeader from '../Layout/ContentHeader'
import LayoutTable from '../Global/LayoutTable'
import { useMutation, useQuery } from '@apollo/client'
import { DELETE_GROUP, GET_ALL_REPORT_GROUPS_BY } from '../../graphql/Catalog/ReportGroups/reportGroups'
import { toastSweetAlert } from '../Helpers/ToastSweetAlert'
import { useLoading } from '../../LoadingOverlay/LoadingOverlayContext'

const ReportGroups = () => {
    //HOOKS:
    const { showLoading, hideLoading } = useLoading()

    //STATES:
    const [dataTable, setDataToTable] = useState([])
    const [total, setTotal] = useState(0)
    const [pagePagination, setPagePagination] = useState({
        searchQuery: null,
        limit: 10,
        offset: 0,
    })

    //MUTATIONS:
    const [deleteGroup] = useMutation(DELETE_GROUP, {
        refetchQueries: [
            {
                query: GET_ALL_REPORT_GROUPS_BY,
                variables: {
                    offset: 0,
                    limit: 10,
                    searchQuery: null,
                },
            },
        ],
    })

    //QUERYS:
    const data = useQuery(GET_ALL_REPORT_GROUPS_BY, {
        variables: { ...pagePagination },
        fetchPolicy: 'no-cache',
    })

    //USE-EFFECTS:
    useEffect(() => { 
        if (!data.loading) {
            if (data.error)
                return toastSweetAlert({
                    mode: 'error',
                    message: data.error.message,
                })

            let list = []
            data.data.getAllGroupsBy?.rows.map((item) => {
                return list.push({
                    id: item.id,
                    nombre: item.name,
                    icono: <img src={item?.IconOfGroup?.url ? item?.IconOfGroup?.url : item.icon} alt="icon" width="30px" height="30px" />,
                    descripcion: item.description.substring(0, 50) + '...',
                })
            })
            setDataToTable(list)
            setTotal(data.data.getAllGroupsBy?.count)
        }
        
    }, [data])

    //FUNCTIONS:
    const handleDelete = async (id) => {
        
        try {

            const response = await toastSweetAlert({
                    mode: 'modalConfirmCancel',
                    title: 'Eliminar Registro',
                    message: `¿Desea continuar?`,
            })
            
            if (response.isConfirmed) {
                showLoading()
                
                const result = await deleteGroup({
                    variables: {
                        deleteGroupId: parseInt(id),
                    }
                })
        
                if (result) {
                    
                    await data?.refetch({
                        variables: {
                            limit: pagePagination.limit,
                            offset: pagePagination.offset,
                            searchQuery: pagePagination.searchQuery,
                        },
                    })
                    
                }
            }
                        
            toastSweetAlert({
                mode: 'ok',
                message: `Grupo de Reportes ${id} eliminado correctamente`,
            })

        } catch (error) {
            return toastSweetAlert({
                mode: 'error',
                message: error.message,
            })

        } finally { 
            hideLoading()
        }
    }

    return (
        <>
            <ContentHeader
                title="Gestor de Grupos de Reportes"
                breadcrumb=""
                windowTitle="Gestor de Grupos de Reportes"
            />

            <LayoutTable                
                title={"Grupos de Reportes"}
                hideDetails                
                hideId
                data={dataTable}
                actionBtnErase={ (e) => handleDelete(e)}
                setPagePagination={setPagePagination}
                pagePagination={pagePagination}
                totalCount={total}
            />
        </>
    )
}
export default ReportGroups